import { 
  DatahubEntity, 
  IDefaultSchema, 
  IPlaybackSchema, 
  PlaybackAction, 
  DATA_VERSION, 
  CaptureEventData,
  CaptureEvent
} from 'src/interfaces/Datahub';
import AplicationService from 'src/services/ApplicationService';

class Playback {
  private defaultData: IDefaultSchema;

  constructor(defaultData: IDefaultSchema) {
    this.defaultData = defaultData;
  }

  play(captureEvent: CaptureEvent<PlaybackAction> ) {
    const currentTime = AplicationService.player?.currentTime || 0;

    const event: IPlaybackSchema = {
      ...this.defaultData,
      time: Math.floor(currentTime)
    };

    const data: CaptureEventData = {
      event,
      data_version: DATA_VERSION['1.0']
    };

    captureEvent(DatahubEntity.PLAYBACK, PlaybackAction.PLAY, data);
  }

  pause(captureEvent: CaptureEvent<PlaybackAction>) {
     const currentTime = AplicationService.player?.currentTime || 0;

     const event: IPlaybackSchema = {
       ...this.defaultData,
       time: Math.floor(currentTime)
     };
 
     const data: CaptureEventData = {
       event,
       data_version: DATA_VERSION['1.0']
     };
 
     captureEvent(DatahubEntity.PLAYBACK, PlaybackAction.PAUSE, data);
   }

} export default Playback;